/**
 * Second view in the MFA activation flow. 
 * Options: totp_uri, validation_token
 * Currently supports application auth only
 */
import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import DialogInterface from '@/interfaces/dialog';
import template from '@/../templates/mfa/dialog-mfa-totp-confirm.hbs';
import QRCode from 'qrcode';

var globalCh = Radio.channel('global');

var alertCh = Radio.channel('alerts');

var success_message = 'Multi-Factor Authentication has been enabled. Next time you log into your Electric Imp account, you\'ll be asked for a second verification step.';

var view = Marionette.View.extend(DialogInterface).extend({
    id: 'enable-mfa-dialog',
    template: Handlebars.compile(template),
    ui: {
        form: 'form',
        canvas_container: '.canvas-container',
        totp_code: '#totp-code',
        submit_btn: '.btn.btn-primary',
    },
    initialize: function (options) {
        this.destroyOnClose();
        this.focusFirstInput();
    },
    onRender: function() {
        var self = this;
        // Create QR code
        QRCode.toCanvas(this.getOption('totp_uri'), function(err, canvas){
            self.ui.canvas_container.append(canvas);
        });
    },
    templateContext: function() {
        // Potentially return a value if QR can't be scanned
        var manual_entry_code = this.getOption('secret') || false;

        return {
            code: manual_entry_code
        };
    },
    events: {
        'submit form': 'onSubmit',
    },
    disableSubmit: function () {
        this.$(this.ui.submit_btn).prop('disabled', true);
    },
    enableSubmit: function () {
        this.$(this.ui.submit_btn).prop('disabled', false);
    },
    onSubmit: function (event) {
        event.preventDefault();
        this.disableSubmit();
        this.ui.submit_btn.attr('disabled', true);
        var self = this;

        var options = {
            verification_token: this.getOption('verification_token'),
            totp_code: this.ui.totp_code.val(),
        };

        this.model.confirm_totp_code(options)
            .done(function(r){
                // Load the main layout again, we are done.
                self.closeDialog();
                alertCh.request('showAlert', {
                    message: success_message,
                    messageType: 'success',
                    timeout: 5000
                });
                globalCh.request('show_mfa', self.model, r.recovery_keys);
                return;                
            })
            .fail(function(err){
                var message = err.responseJSON.errors[0].detail || 'We\'re sorry, something has gone wrong, please try again';
                self.showAlert('error', message);
                self.ui.submit_btn.attr('disabled', false);
            });

    },
});

export default view;

